import { 
  criticalComponentFactory, 
  importantComponentFactory, 
  deferredComponentFactory 
} from '@utils';

// Critical - Components needed for immediate interaction
// These will be preloaded with highest priority
const CriticalComponents = {
  ['product-gallery']: criticalComponentFactory('ui/ProductGallery'),
  ProductForm: criticalComponentFactory('ui/ProductForm'),
  ProductVariantSelector: criticalComponentFactory('ui/VariantSelector'),
  QuantityInput: criticalComponentFactory('ui/QuantityInput'),
};

// Important - Components needed soon after page load
// These will be prefetched when browser is idle
const ImportantComponents = {
  MainCart: importantComponentFactory('ui/Cart/MainCart'),
  MiniCart: importantComponentFactory('ui/MiniCart'),
  QuickSearch: importantComponentFactory('ui/QuickSearch'),
  DesktopNav: importantComponentFactory('nav/DesktopNav'),
};

// Deferred - Components that can wait
// These will only load when needed
const DeferredComponents = {
  Accordion: deferredComponentFactory('ui/Accordion'),
  CustomSelect: deferredComponentFactory('ui/CustomSelect'),
  Drawer: deferredComponentFactory('ui/Drawer'),
  FacetFilters: deferredComponentFactory('ui/FacetFilters'),
  ImageComparison: deferredComponentFactory('ui/ImageComparison'),
  MobileSearch: deferredComponentFactory('ui/MobileSearch'),
  Modal: deferredComponentFactory('ui/Modal'),
  ProductRecommendations: deferredComponentFactory('ui/ProductRecommendations'),
  Slider: deferredComponentFactory('ui/Slider'),
  BannerSlider: deferredComponentFactory('ui/BannerSlider'),
  Tabs: deferredComponentFactory('ui/Tabs'),
  ['video-player']: deferredComponentFactory('media/VideoPlayer'),
  MobileNav: deferredComponentFactory('nav/MobileNav'),
};

const AppComponents = {
  ...CriticalComponents,
  ...ImportantComponents,
  ...DeferredComponents,
};

export default AppComponents;
